var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbAccountingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8 1.2H11.2C12.1941 1.2 13 2.00589 13 3V12.2C13 12.6418 12.6418 13 12.2 13H2.8V1.2Z",
    fill: "currentColor",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0.8C1.33726 0.8 0.8 1.33726 0.8 2V12C0.8 12.6627 1.33726 13.2 2 13.2H12.2C12.7523 13.2 13.2 12.7523 13.2 12.2V3C13.2 1.89543 12.3046 1 11.2 1H2V0.8ZM1.8 2C1.8 1.88954 1.88954 1.8 2 1.8H2.6V12.2H2C1.88954 12.2 1.8 12.1105 1.8 12V2ZM3.6 12.2H12.2V3C12.2 2.44772 11.7523 2 11.2 2H3.6V12.2Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 0.8V4.8L6.1 3.8L7.4 4.8V0.8H4.8Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 5.8H9.8M5.5 6.9H8.5M5.5 5.8V10.2M7.5 6.9C7.5 7.9 6.7 8.3 5.5 8.3M7.2 8.3L9.5 10.4",
    stroke: "currentColor",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbAccountingIcon);
export default __webpack_public_path__ + "static/media/ab_accounting_icon.9815f6e0b5efc6f57ba81cd1b93fbee0.svg";
export { ForwardRef as ReactComponent };